import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { makeStyles } from '@material-ui/core/styles';
import { configsSelector } from '../../store/reducers/servicesConfigs';
import {
  settingsArraySelector,
  settingsArrayToObject,
} from '../../store/reducers/settings';
import { getSettings, setSettings } from '../../store/actions/settings';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    border: '1px solid #a9a9a9',
    borderRadius: 4,
  },
  tableContainer: {
    maxHeight: 'calc(95vh - 200px)',
  },
  bold: {
    marginBottom: theme.spacing(2),
    fontWeight: 700,
  },
  blueButton: {
    backgroundColor: '#2ca0f7',
    color: 'white',
    textTransform: 'none',
    fontFamily: 'Exo 2',
  },
  select: {
    margin: theme.spacing(2),
    minWidth: 300,
  },
}));

export default () => {
  const classes = useStyles();
  const [currentConfig, setCurrentConfig] = useState(0);
  const configs = useSelector(configsSelector);
  const settings = useSelector(settingsArraySelector);
  const envToSetting = Object.fromEntries(
    settings.map((setting) => [setting.env, setting])
  );

  const config = configs[currentConfig];
  const configOptions = configs.map(({ host, port }) => `${host}:${port}`);
  const dispatch = useDispatch();

  const { handleSubmit, control, errors, reset } = useForm();

  const onConfigChange = ({ target }) => {
    setCurrentConfig(target.value);
  };

  const onSubmit = handleSubmit((values) => {
    const newSettings = settingsArrayToObject(
      Object.entries(values).map(([env, value]) => ({
        ...envToSetting[env],
        value,
      }))
    );
    dispatch(setSettings(config, newSettings));
  });

  useEffect(() => {
    dispatch(getSettings(config));
  }, [config]);

  useEffect(() => {
    if (settings.length) {
      reset(Object.fromEntries(settings.map(({ env, value }) => [env, value])));
    }
  }, [settings]);

  return {
    ...config,
    configOptions,
    currentConfig,
    classes,
    settings,
    control,
    errors,
    onSubmit,
    onConfigChange,
  };
};
